import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border rounded-4 p-4 pb-2" }
const _hoisted_2 = { class: "d-flex justify-content-between border-bottom pb-1" }
const _hoisted_3 = { class: "fw-bold" }

import { Notification as AppNotification } from '@/guiide/ts/notifications/notification';
import { formatter } from '@/shared/ts/formatter';


export default /*@__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
    notification: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.notification.title), 1),
      _createElementVNode("span", null, _toDisplayString(_unref(formatter).standardDate(_ctx.notification.issueDate)), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notification.content, (contentElement, i) => {
      return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(contentElement), 1))
    }), 128))
  ]))
}
}

})